import { render } from "./LivrateurView.vue?vue&type=template&id=03a75e7f"
import script from "./LivrateurView.vue?vue&type=script&lang=js"
export * from "./LivrateurView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__